import { useMemo } from 'react';
import { Controller } from 'react-hook-form';

import { type ListEpmMasterAllocationKeysQuery, useListEpmMasterAllocationKeysQuery } from '@/common/graphql';
import { getAllocationKeyTotal, MAX_ALLOCATION_KEY_ENTRIES } from '@/common/types';
import { AllocationField } from './AllocationField';
import { AllocationPercentageInput } from './AllocationPercentageInput';
import { AllocationSelectInput } from './AllocationSelectInput';
import type { AllocationFieldProps } from './props';
import { useGetComboboxData } from './useGetComboboxData';

export const AllocationFieldAllocationKey = ({
  append,
  control,
  errors,
  fields,
  register,
  remove,
  watched,
}: AllocationFieldProps<'allocationKey'>) => {
  const total = useMemo(() => getAllocationKeyTotal(watched), [watched]);
  const { options, loading } = useGetComboboxData<ListEpmMasterAllocationKeysQuery>(
    useListEpmMasterAllocationKeysQuery,
    'listEpmMasterAllocationKeys',
  );

  return (
    <AllocationField
      addLabel="Add Allocation Key"
      errors={errors}
      fields={fields}
      formKey="allocationKey"
      loading={loading}
      maxEntries={MAX_ALLOCATION_KEY_ENTRIES}
      optional={true}
      title="Allocation Key"
      total={total}
      onAdd={() => append({ epmMasterAllocationKeyId: '', percentage: 0 })}
      onRemove={remove}
      renderRowContent={i => {
        const alreadySelected = watched.slice(0, i).map(it => it.epmMasterAllocationKeyId);
        return (
          <>
            <Controller
              control={control}
              name={`allocationKey.${i}.epmMasterAllocationKeyId`}
              render={({ field }) => (
                <AllocationSelectInput
                  autoSelectSingle={true}
                  data={options.filter(it => !alreadySelected.includes(it.value))}
                  disabled={loading}
                  placeholder="Allocation Key"
                  value={field.value || null}
                  onChange={val => field.onChange(val ?? '')}
                />
              )}
            />
            <AllocationPercentageInput
              registration={register(`allocationKey.${i}.percentage`, { valueAsNumber: true })}
              disabled={loading}
            />
          </>
        );
      }}
    />
  );
};
